import styled from "styled-components/macro";
import { InputDatePicker, LabelStringColumn, PrimaryButton, ButtonText } from "@loanbossinc/component-library";

export const InputWrapper = styled.div`
  && {
    margin-top: 1em;
    width: 100%;
    min-width: 384px;
  }
`;

export const InputName = styled(LabelStringColumn)`
  && {
    color: #5f6368;
    margin-bottom: 0.5em;
    margin-top: 0.75em;
  }
`;

export const DatePicker = styled(InputDatePicker)`
  && {
    margin-bottom: 0.75em;
  }
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  && {
    background: #005aa9;
    margin-top: 3em;
    width: auto;
    font-size: 13px;
  }
`;

export const CheckboxGroup = styled.div`
  && {
    display: flex;
    flex-direction: column;
    justify-content: left;
  }
`;

export const CheckboxContainer = styled.div`
  && {
    color: black;
    display: flex;
    align-items: center;
    margin-left: -14px;
  }
`;

export const BackButton = styled(ButtonText)`
  && {
    display: flex;
    justify-content: flex-start;
    margin-left: -0.5em;
    .label {
      margin-left: 1em;
    }
  }
`;

export const FinishButtonWrapper = styled.div`
  && {
    display: flex;
    flex: 2;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
  }
`;

export const Container = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const Avatar = styled.div`
  && {
    background: linear-gradient(212.88deg, #dfeffc 6.86%, rgba(249, 249, 249, 0) 116.99%);
    border-radius: 50%;
    height: 150px;
    margin: 3em 1em;
    width: 150px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const Title = styled.span`
  && {
    align-items: center;
    color: #000000;
    display: flex;
    font-family: Work Sans;
    font-size: 20px;
    font-style: normal;
    font-weight: normal;
    line-height: 23px;
    text-align: center;
  }
`;

export const DealName = styled.span`
  && {
    align-items: center;
    color: #3f9ff4;
    display: flex;
    font-family: Work Sans;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px;
    margin-bottom: 1.5em;
    margin-top: 1em;
    text-align: center;
  }
`;

export const ReportName = styled.span`
  && {
    align-items: center;
    color: #5f6368;
    display: flex;
    font-family: Work Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
    margin-bottom: 1.5em;
    text-align: center;
  }
`;

export const Card = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const WorkflowLinkWrapper = styled.button`
  && {
    align-items: center;
    background-color: #fafafa;
    border: 1px solid #005aa9;
    box-sizing: border-box;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    height: 84px;
    justify-content: left;
    margin-top: 1em;
    padding: 1em;
    width: 384px;
  }
`;

export const Step3ButtonBar = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 2em;
    width: 100%;
  }
`;

export const WorkflowLinkIcon = styled.div`
  && {
    padding: 1em;
    width: 30px;
  }
`;

export const WorkflowLinkContent = styled.div`
  && {
    padding: 1em;
    text-align: left;
  }
`;

export const WorkflowLinkContentTitle = styled.div`
  && {
    color: #000000;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 19px;
  }
`;

export const WorkflowLinkContentDate = styled.div`
  && {
    color: #5f6368;
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    line-height: 16px;
    margin-top: 0.35em;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const BackDeleteWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-top: 3em;
`;

export const StyledDeleteButton = styled(ButtonText)`
  color: red !important;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;
